export default {
  namespaced: true,

  state: () => ({
    seo: {},
  }),

  mutations: {
    setSeo: (state, data) => state.seo = data,
  },

  actions: {
    async loadSeo({ commit }, { url }) {
      try {
        const { title, description, canonical } = await this.$api.loadSeoOne({ url });
        commit('setSeo', { title, description, canonical });
      } catch (e) {
        commit('setSeo', {});
      }
    },
  },
};
